import HelpAFriend from "containers/HelpAFriend";
import { DataContextProvider } from "contexts/DataContext";
import { MobileMenuContextProvider } from "contexts/MobileMenuContext";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import PropTypes from "prop-types";
import StickyBottomBarAdapter from "../adapters/StickyBottomBar";

const ReferralTemplate = ({
  cmsLanguagesData,
  trustpilotInfo,
  campaignId,
  story: {
    tag_list: tagList,
    content: { campaignSource, commissionValue, stickyBottomBarHeading, hideStickyBottomBar, stickyBottomBarVariant },
  },
  whiteListDomains,
  serverSideStoryblokPages,
}) => (
  <DataContextProvider
    data={{
      trustpilotInfo,
      cmsLanguagesData,
      referralProgramConfig: { campaignId, campaignSource, commissionValue },
      whiteListDomains,
      serverSideStoryblokPages,
    }}
  >
    <StickyBottomBarContextProvider threshold={0.4}>
      <MobileMenuContextProvider>
        <ModalContextProvider>
          <HelpAFriend noindex={tagList.includes("noindex")} />
        </ModalContextProvider>
      </MobileMenuContextProvider>
      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
      />
    </StickyBottomBarContextProvider>
  </DataContextProvider>
);

ReferralTemplate.propTypes = {
  trustpilotInfo: PropTypes.shape({
    numberOfReviews: PropTypes.shape({
      total: PropTypes.number,
    }),
    score: PropTypes.shape({
      trustScore: PropTypes.number,
    }),
  }).isRequired,
  cmsLanguagesData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  campaignId: PropTypes.string.isRequired,
  story: PropTypes.shape({
    tag_list: PropTypes.arrayOf(PropTypes.string),
    content: PropTypes.shape({
      campaignSource: PropTypes.string,
      commissionValue: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
  whiteListDomains: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      dimension_value: PropTypes.string,
    })
  ),
  serverSideStoryblokPages: PropTypes.shape({}).isRequired,
};

ReferralTemplate.defaultProps = {
  whiteListDomains: [],
};

export default ReferralTemplate;
